import CandidateExpertiseItem from './CandidateExpertiseItem.component';
import ProfileInfoPreview from '../ProfileInfoPreview';

export type CandidateExpertiseItemProps = {
  id?: string;
  skillName?: string;
  skillId?: string;
  experience: string;
  description: string;
  isMainStack: boolean;
  tags: string[];
  subSkills: string[];
  onDeleteExpertise: () => void;
  onSaveExpertise: (values: any) => void;
  onEditExpertise: () => void;
  onCancelExpertiseEdition: () => void;
  isEditing?: boolean;
};

const CandidateExpertiseItemContainer = ({
  isEditing,
  ...props
}: CandidateExpertiseItemProps): JSX.Element => {
  return isEditing ? (
    <CandidateExpertiseItem {...props} tags={props.subSkills} />
  ) : (
    <ProfileInfoPreview
      tooltipMessage={props.isMainStack ? 'Is main stack' : undefined}
      title={props.skillName ?? ''}
      subtitle={props.experience}
      skills={props.tags}
      description={props.description}
      onDelete={props.onDeleteExpertise}
      onEditInfo={props.onEditExpertise}
    />
  );
};

export default CandidateExpertiseItemContainer;
